/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Supplier} from './Supplier';

/**
 * The ComparedBasketsInner model module.
 * @module model/ComparedBasketsInner
 * @version v1
 */
export class ComparedBasketsInner {
  /**
   * Constructs a new <code>ComparedBasketsInner</code>.
   * @alias module:model/ComparedBasketsInner
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ComparedBasketsInner</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ComparedBasketsInner} obj Optional instance to populate.
   * @return {module:model/ComparedBasketsInner} The populated <code>ComparedBasketsInner</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ComparedBasketsInner();
      if (data.hasOwnProperty('supplier'))
        obj.supplier = Supplier.constructFromObject(data['supplier']);
      if (data.hasOwnProperty('items'))
        obj.items = ApiClient.convertToType(data['items'], [Object]);
      if (data.hasOwnProperty('subtotal_in_cents'))
        obj.subtotal_in_cents = ApiClient.convertToType(data['subtotal_in_cents'], 'Number');
      if (data.hasOwnProperty('total_in_cents'))
        obj.total_in_cents = ApiClient.convertToType(data['total_in_cents'], 'Number');
      if (data.hasOwnProperty('total_vs_cheapest_variance_percent'))
        obj.total_vs_cheapest_variance_percent = ApiClient.convertToType(data['total_vs_cheapest_variance_percent'], 'String');
      if (data.hasOwnProperty('percent_value_vs_cheapest'))
        obj.percent_value_vs_cheapest = ApiClient.convertToType(data['percent_value_vs_cheapest'], 'String');
      if (data.hasOwnProperty('unit_price_varience_over_threshold_count'))
        obj.unit_price_varience_over_threshold_count = ApiClient.convertToType(data['unit_price_varience_over_threshold_count'], 'Number');
      if (data.hasOwnProperty('direct_overall_calculation'))
        obj.direct_overall_calculation = ApiClient.convertToType(data['direct_overall_calculation'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {module:model/Supplier} supplier
 */
ComparedBasketsInner.prototype.supplier = undefined;

/**
 * @member {Array.<Object>} items
 */
ComparedBasketsInner.prototype.items = undefined;

/**
 * @member {Number} subtotal_in_cents
 */
ComparedBasketsInner.prototype.subtotal_in_cents = undefined;

/**
 * @member {Number} total_in_cents
 */
ComparedBasketsInner.prototype.total_in_cents = undefined;

/**
 * @member {String} total_vs_cheapest_variance_percent
 */
ComparedBasketsInner.prototype.total_vs_cheapest_variance_percent = undefined;

/**
 * @member {String} percent_value_vs_cheapest
 */
ComparedBasketsInner.prototype.percent_value_vs_cheapest = undefined;

/**
 * @member {Number} unit_price_varience_over_threshold_count
 */
ComparedBasketsInner.prototype.unit_price_varience_over_threshold_count = undefined;

/**
 * @member {Number} direct_overall_calculation
 */
ComparedBasketsInner.prototype.direct_overall_calculation = undefined;

